query GetContact($id: ID!) {
  contact(id: $id) {
    id
    name
    salesforceId
    firstName
    lastName
    createdAt
    updatedAt
    email
    alternativeEmail
    title
    gender
    phoneCountryCode
    phoneNumber
    testRecord
    responsivenessStatus
    responsivenessDetails
    responsivenessNotes
    responsivenessDateLastUpdated
    typeOfStewardship
    isMember
    membershipOverride
    memberOffBoarded
    membershipJoinDate
    sourceType
    connectedOnLinkedInWithDavid
    source
    memberValueScore
    memberValueScoreTier
    totalPledgeValue {
      minorUnit
      currency
    }
    liquidityToDate {
      minorUnit
      currency
    }
    moneyGiftedToCharitableSector {
      minorUnit
      currency
    }
    totalGrants {
      minorUnit
      currency
    }
    futurePledgeValue {
      minorUnit
      currency
    }
    unrecordedLiquidity {
      minorUnit
      currency
    }
    moneyDueToCharitableSector {
      minorUnit
      currency
    }
    influencedHifoGrants {
      minorUnit
      currency
    }
    firstPledgeDateSigned
    mailingStreet
    mailingCity
    mailingPostalCode
    mailingState
    mailingCountry
    singlePointOfContact {
      id
      name
    }
    communityManager {
      id
      name
    }
    advisor {
      id
      name
    }
    initialCloser {
      id
      name
    }
    mainRole
    linkedInProfile
    estimatedNetWorthUsd {
      minorUnit
      currency
    }
    isPledgeVenturesLp
    isMembersPartnerOrSpouse
    isCurrentDonor
    eventLocationsOfInterest
    canReceiveEventInvites
    optedOutOfWinterRetreats
    optedOutOfCommunityEvents
    optedOutOfSummerRetreats
    preferredMethodsOfCommunication
    isConfidential
    motivation
    involvement
    causeAreas
    causeAreaGroups
    advisoryJourney
    beneficiaries
    eventSpeakerStatus
    socialThinkingNotes
    motivationNotes
    involvementNotes
    familyNotes
    eventSpeakerBiography
    eventInternalSpeakerNotes
    notes
    communityNextSteps
    eventNotes
    advisoryNotes
    deploymentNotes
    aiSummary
  }
}
